import { Component, Input, OnInit } from '@angular/core';
import { DigitalisProduct, Option } from '@dch/products-business-logic';
import { Alert, AlertsService } from '@proximus/ng-common-components';
import { TranslationService } from '@proximus/ng-common';
import { getDescriptionMessage } from '../../../../../../shared/order-utils/order-utils';

@Component({
  selector: 'mprd-emarketing',
  templateUrl: './emarketing.component.html',
})
export class EmarketingComponent implements OnInit {
  @Input() options: Option[];
  @Input() selectedProduct: DigitalisProduct;
  eMarketingOption: Option;
  orderButtonsDisabled = false;
  displayPendingOrderAlert = false;

  constructor(
    private translationService: TranslationService,
    private alertService: AlertsService,
  ) {}

  ngOnInit(): void {
    this.eMarketingOption = this.options.find(
      (option) => option.optionCodeForDescription === 'CIYCV',
    );
  }

  onResult(event) {
    if (event?.action && event?.action === 'aiaPending') {
      this.displayPendingOrderAlert = true;
    } else if (event && event.orderingInProgress) {
      this.orderButtonsDisabled = true;
    } else if (event && event.type && event.type === 'success') {
      if (event.action && event.action === 'add') {
        this.dispatchAlert(
          event.type,
          event.mpcUuid,
          this.translationService.getTranslatedValueFor(
            'message.confirmation.title',
          ),
          this.translationService.getTranslatedValueFor(
            'message.confirmation.description',
          ),
        );
        this.orderButtonsDisabled = true;
      }
    } else if (event && event.type && event.type === 'error') {
      if (event.suspended) {
        this.dispatchAlert(
          event.type,
          event.mpcUuid,
          this.translationService.getTranslatedValueFor('message.error.title'),
          this.translationService.getTranslatedValueFor(
            'message.error.description.frozenAssets',
          ),
        );
        this.orderButtonsDisabled = false;
      } else if (event.action && event.action === 'add') {
        this.dispatchAlert(
          event.type,
          event.mpcUuid,
          this.translationService.getTranslatedValueFor('message.error.title'),
          getDescriptionMessage(event, this.translationService),
        );
        this.orderButtonsDisabled = false;
      }
    }
  }

  private dispatchAlert(
    type: 'error' | 'info' | 'success' | 'warning',
    mpcuuid: string,
    title: string,
    description: string,
  ): void {
    const alert: Alert = {
      isClosable: true,
      alertKey: 'eMarketingAlert',
      title,
      description,
      type,
      scrollTo: true,
      scrollOffset: 200,
    };
    this.alertService.dispatchAlert(alert);
  }
}
